export default __webpack_public_path__ + "static/media/famouscollage.18016d46.jpg";